import React, { useEffect, useRef, useState } from "react";

import Logo from "../Logo/Logo";
import blueLogo from "../../assets/blueLogo.svg";
import { getEvents, getGuests, getStates, getVendors } from "../../mockApi";
import { Link } from "react-router-dom";
import EventInfo from "./EventInfo";
import SelectVendor from "./SelectVendor";
import Negotiate from "./Negotiate";
import ContactDetails from "./ContactDetails";
import Successful from "./Successful";
import "./PageLayout.css";
import "../Button/Button.css"
import { Helmet } from "react-helmet-async";

const whyQuickplanners = [
  {
    sn: 1,
    name: "Skip the Back-and-Forth",
    title:
      "We only match you with vendors who are available, fit your budget, and can actually deliver—so you save time and avoid endless negotiations.",
  },
  {
    sn: 2,
    name: "Work with Verified Pros",
    title:
      "Every vendor on Quickplanners is carefully vetted and verified, so you’re always dealing with trusted professionals.",
  },
  {
    sn: 3,
    name: "Plan with Confidence",
    title:
      "Know you're working with people who take your event as seriously as you do—no guesswork, no stress.",
  },
];

const PageLayout = () => {
  const [page, setPage] = useState(0);
  const [eventData, setEventData] = useState({
    eventType: "",
    eventDate: "",
    eventDuration: "",
    state: "",
    guests: "",
    hasVenue: true,
    venueName: "",
    eventName: "",
    venueLocation: "",
    proposedVenueType: "Indoor",
    venueType: "Indoor",
    otherProposedVenueType: "",
    hasMoreInfo: false,
    additionalInfo: "",
    budget: "",
    budgetAmount: "",
    budgetEstimate: "",
    vendors: [],
    servicesData: [],
    startDate: "",
    endDate: "",
    moreInfo: "",
    fullName: "",
    phone: "",
    email: "",
  });

  const [currentStep, setCurrentStep] = useState(1);
  const [isComplete, setIsComplete] = useState(false);
  const [margins, setMargins] = useState({
    marginLeft: 0,
    marginRight: 0,
  });
  const stepRef = useRef([]);
  const [states, setStates] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [guests, setGuests] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [categoryError, setCategoryError] = useState([]);

  useEffect(() => {
    if (stepRef.current.length > 0) {
      setMargins({
        marginLeft: stepRef.current[0]?.offsetWidth / 2 || 0,
        marginRight:
          stepRef.current[stepRef.current.length - 1]?.offsetWidth / 2 || 0,
      });
    }

    getVendors().then((data) => {
      setVendors(data.vendors);
      console.log(vendors);
    });

    getStates().then((data) => {
      setStates(data.states);
    });

    getEvents().then((data) => {
      setEvents(data.events);
    });

    getGuests().then((data) => {
      setGuests(data.guests);
    });
  }, [stepRef.current]);

  const calculateProgressBarWidth = () => {
    return ((currentStep - 1) / (FormTitles.length - 1)) * 100;
  };

  const FormTitles = [
    "Event Info",
    "Select Vendor",
    "Negotiate",
    "Contact Details",
  ];

  const validateEventDetails = () => {
    const newErrors = {};

    if (!eventData.eventType) newErrors.eventType = "Type of event is required";

    if (!eventData.eventName)
      newErrors.eventName = "Assign a name to this event is required";

    if (eventData.hasVenue && !eventData.venueName)
      newErrors.venueName = "Name of venue is required";

    if (eventData.hasVenue && !eventData.venueLocation)
      newErrors.venueLocation = "Location of venue is required";

    if (eventData.hasVenue && !eventData.venueType)
      newErrors.venueType = "Type of venue is required";

    if (eventData.eventDuration === "single" && !eventData.eventDate) {
      newErrors.eventDate = "Date of event is required";
    }
    if (eventData.eventDuration === "multiple" && !eventData.startDate) {
      newErrors.startDate = "Start Date of event is required";
    }
    if (eventData.eventDuration === "multiple" && !eventData.endDate) {
      newErrors.endDate = "End Date of event is required";
    }
    if (eventData.venueType === "Other" && !eventData.otherVenueType) {
      newErrors.otherVenueType = "Venue Type is required";
    }
    if (
      !eventData?.hasVenue &&
      eventData.proposedVenueType === "Other" &&
      !eventData.otherProposedVenueType
    ) {
      newErrors.otherProposedVenueType = "Venue Type is required";
    }
    if (!eventData.eventDuration) {
      newErrors.eventDuration = "Event Duration is required";
    }
    if (!eventData.state) {
      newErrors.state = "State of event is required";
    }
    if (!eventData.guests) {
      newErrors.guests = "Number of guests is required";
    }

    setErrors(newErrors);

    setTimeout(() => {
      setErrors({});
    }, 10000);

    return Object.keys(newErrors).length === 0;
  };

  const validateCategoryDetails = () => {
    const newErrors = {};

    if (!eventData.vendors || eventData.vendors.length === 0)
      newErrors.category = "Please select a service";

    setCategoryError(newErrors);

    setTimeout(() => {
      setCategoryError({});
    }, 10000);

    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    console.log(eventData);
    console.log(errors);
    console.log("Category error :", categoryError);
    if (page === 0) {
      if (validateEventDetails()) {
        setPage((currPage) => currPage + 1);
        setCurrentStep((prevStep) => prevStep + 1);
      }
    } else if (page === 1) {
      if (validateCategoryDetails()) {
        setPage((currPage) => currPage + 1);
        setCurrentStep((prevStep) => prevStep + 1);
      }
    } else if (page === FormTitles.length - 1) {
      setSubmitted(true);
      setPage((currPage) => currPage + 1);
      setCurrentStep((prevStep) => prevStep + 1);
    } else {
      setPage((currPage) => currPage + 1);
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrevious = () => {
    setCurrentStep((prevStep) => {
      if (prevStep === 1) {
        return prevStep;
      } else {
        setPage((currPage) => currPage - 1);
        return prevStep - 1;
      }
    });
  };

  const PageDisplay = () => {
    if (submitted) {
      return <Successful />;
    }

    if (page === 0) {
      return (
        <EventInfo
          eventData={eventData}
          setEventData={setEventData}
          states={states}
          events={events}
          guests={guests}
          errors={errors}
        />
      );
    } else if (page === 1) {
      return (
        <SelectVendor
          eventData={eventData}
          setEventData={setEventData}
          states={states}
          vendors={vendors}
          categoryError={categoryError}
        />
      );
    } else if (page === 2) {
      return <Negotiate eventData={eventData} setEventData={setEventData} />;
    }
     else {
      return (
        <ContactDetails eventData={eventData} setEventData={setEventData} />
      );
    }
  };

  return (
    <>
    <Helmet>
        <title>Let’s connect you with reliable vendors.</title>
        <meta name="description" content="Tell us your event needs, and we’ll connect you with the right vendors — from decorators to caterers — fast, easy, and worry-free." />
    </Helmet>
    <div className="content">
      <section className="d-flex vendor-registeration">
        <div className="side">
          <div className="logo">
            <Logo />
          </div>

          <h2 className="sub-head">Why You’ll Love Using Quickplanners</h2>

          <div className="register-reason">
            <div>
              {whyQuickplanners.map((item) => (
                <div className="reason-item d-flex gap-3" key={item.sn}>
                  <div className="reason-icon">
                    <p className="sn">{item.sn}</p>
                  </div>
                  <div className="reason-items">
                    <p className="">{item.name}</p>
                    <span className="">{item.title}</span>
                  </div>
                </div>
              ))}{" "}
            </div>
          </div>
        </div>

        <div className="main">
          <Link to="/">
            <img src={blueLogo} alt="Logo" className="blue-logo" />
          </Link>

          <h2 className="main-head">Connect With Vendors</h2>

          <p className="sub-para">Let’s connect you with reliable vendors</p>
          <div className="stepper">
            {FormTitles.map((title, index) => (
              <div
                key={title}
                ref={(el) => (stepRef.current[index] = el)}
                className={`step ${
                  currentStep > index + 1 || isComplete ? "complete" : ""
                } ${currentStep === index + 1 ? "active" : ""}`}
              >
                <div className="step-number">
                  {currentStep > index + 1 || isComplete ? (
                    <span>&#10003;</span>
                  ) : currentStep === index + 1 ? (
                    <span>&#x3f;</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ))}

            <div
              className="progress-bar"
              style={{
                width: `calc(100% - ${
                  margins.marginLeft + margins.marginRight
                }px)`,
                marginLeft: margins.marginLeft,
                marginRight: margins.marginRight,
              }}
            >
              <div
                className="progress"
                style={{ width: `${calculateProgressBarWidth()}%` }}
              ></div>
            </div>
          </div>

          {/* Form details */}

          <div className="">
            <div className="progressbar">
              <div
                style={{
                  width: page === 0 ? "33.3%" : page === 1 ? "66.6%" : "100%",
                }}
              ></div>
            </div>
            <div className="form-container">
              <div className="body">{PageDisplay()}</div>
              <div className="">
                <div className="d-flex justify-content-between align-items-center stepper-nav">
                  {currentStep > 1 && !submitted && (
                    <button
                      className="step-btn btn-ghost d-flex align-items-center gap-3 complete"
                      onClick={handlePrevious}
                    >
                      Back
                    </button>
                  )}
                  <div></div>

                  {!isComplete && !submitted && (
                    <>
                      {!submitted && currentStep === FormTitles.length ? (
                        <>
                          <button
                            className={`step-btn btn-full d-flex align-items-center gap-3 ${
                              currentStep === FormTitles.length
                                ? "complete"
                                : ""
                            }`}
                            onClick={handleNext}
                          >
                            {!loading && "Pay and Submit Listing"}{" "}
                            {loading && (
                              <div
                                className="spinner-border text-light"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            )}
                          </button>
                        </>
                      ) : (
                        <button
                          className={`step-btn btn-full d-flex align-items-center gap-3 complete `}
                          onClick={() => handleNext()}
                        >
                          {" "}
                          Next{" "}
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
    
  );
};

export default PageLayout;
